import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Typography, Empty, Button, Image, Modal } from 'antd';

import { Field, GET, POSTFormData, useAuth, useMetaContext, useUserContext, ycStorage } from 'fennec-ui';

import { Action, errorCatch, Model, POST } from 'fennec-ui';
import UserUpdate from '../../../desktop/forms/UserUpdate';
import "./index.less"
import { ycBucket } from '../../../components/Tool';
import Icofont from 'react-icofont';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import TelegramLoginButton from '../../../components/TelegramLoginButton';

export default function CommonProfile(props) {
	const auth = useAuth();
	const meta = useMetaContext();
	const user = useUserContext();
	const dispatch = useDispatch();

	const vkbot = process.env.REACT_APP_VKBOT
	const tgbot = process.env.REACT_APP_TGBOT

	const imageUrl = useMemo(() => {
		return { file: (user.avatar) ? ycStorage(auth) + ycBucket(auth) + "/" + user.avatar : "" }
	}, [user.avatar])

	const handleTelegramResponse = response => {
		console.log(response);
	};

	const tgUnlink = () => {
		Modal.confirm({
			title: `Вы уверены что хотите отвязать акканут Федерации от Telegram-чата?`,
			icon: <ExclamationCircleOutlined />,
			content: <div>Отвязав аккаунт от чата Вы перестанете получать уведомления Федерации и информацию о Ваших мероприятиях и билетах.</div>,
			okText: "Да, отвязать",
			okType: 'danger',
			cancelText: "Нет",
			onOk: () => {
				GET(auth, `/api/tg/unlink`, ({ data }) => {
					dispatch({ type: 'USER', payload: data })
				}, errorCatch)
			},
			// onCancel: unlock
		});
	}
	const vkUnlink = () => {
		Modal.confirm({
			title: `Вы уверены что хотите отвязать акканут Федерации от VK-чата?`,
			icon: <ExclamationCircleOutlined />,
			content: <div>Отвязав аккаунт от чата Вы перестанете получать уведомления Федерации и информацию о Ваших мероприятиях и билетах.</div>,
			okText: "Да, отвязать",
			okType: 'danger',
			cancelText: "Нет",
			onOk: () => {
				GET(auth, `/api/vk/unlink`, ({ data }) => {
					dispatch({ type: 'USER', payload: data })
				}, errorCatch)
			},
			// onCancel: unlock
		});
	}
	return (
		<div style={{ display: "flex" }}>
			<div className='profile-banner' style={{ flex: "1 0", marginRight: "10px", padding: "5px", backgroundColor: "white", borderRadius: "4px" }}>
				<div style={{
					display: "flex",
					flexDirection: "column",
					alignItems: "center"
				}}>
					<div style={{ display: "flex", gap: "5px", padding: "5px 0px 5px 0px" }}>
						<Action
							auth={auth}
							mode={'func'}
							trigger={(click) => (<div>
								<div style={{ margin: "0px 0px", alignSelf: "center", cursor: "pointer" }} onClick={click}>
									<Image
										fallback={"data:image/png;base64,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"}
										preview={false}
										width={200}
										height={200}
										style={{ borderRadius: "6px", border: "1px solid #e5e5e5" }}
										src={(user.avatar) ? ycStorage(auth) + ycBucket(auth) + "/" + user.avatar : ""}
									/>
								</div>
							</div>)}
							isFormData={true}
							action={(values, unlock, close, { collection, setCollection }) => {
								POSTFormData(auth, `/api/set-avatar`, values,
									({ data }) => {
										dispatch({ type: 'USER', payload: data })
										close();
									},
									(err) => errorCatch(err, unlock));
							}}
							object={imageUrl}
							form={Model}
							meta={[
								{
									name: "file",
									type: "image",
									label: "Аватарка",
								},
							]}
							title="Загрузить фото"
							modal={{
								width: "600px",
								title: "Загрузить фото",
							}}
						/>
					</div>
				</div>
			</div>
			<div style={{ flex: "1", padding: "20px", borderRadius: "4px", backgroundColor: "white" }}>
				{user && <div>

					<div style={{
						padding: "10px 0px", display: "flex", justifyContent: "space-between", gap: "10px",
						backgroundColor: "#f7f7f7",
						padding: "10px",
						alignItems: "center",
						borderRadius: "4px",
						marginBottom: "15px"
					}}>
						<div style={{ flex: "1" }}>
							{user.email}
						</div>
						<div style={{ flex: "0" }}>
							<Action
								mode={'func'}
								trigger={(click) => (<Button onClick={click}>Изменить</Button>)}
								title={"Изменить адрес электронной почты"}
								modal={{
									width: "450px",
									title: "Изменить адрес электронной почты",
								}}
								action={(values, unlock, close, { collection, setCollection }) => {
									GET(auth, '/api/email-verification-pincode?pincode=' + values.verifyemail.pincode,
										({ data }) => {
											if (data) {
												dispatch({ type: 'USER', payload: data })
											}
											close();
										}, (err) => errorCatch(err, unlock)
									);
								}}
								steps={[
									{
										key: "emailchange",
										name: "Шаг 1",
										action: (values, unlock, close) => {
											POST(auth, "/api/create-email-verification", values,
												(res) => {
													close();
												}, (err) => errorCatch(err, unlock));
										},
										form: Model,
										meta: [
											{
												label: "Ноый адрес электронной почты",
												name: "email",
												type: "string",
											},
											{
												label: "Введите действующий пароль",
												name: "password",
												type: "password",
											},
										],
									},
									{
										key: "verifyemail",
										name: "Шаг 2",
										form: Model,
										meta: [
											{
												type: "func",
												render: (auth, item, value, onChange) => (<div>На указанную Вами электронную почту было отправлено письмо содержащее пинкод для подтвеждения адреса. Ввведите пинкод из электронного письма в поле ниже.</div>)
											},
											{
												label: "Пин-код",
												name: "pincode",
												type: "string",
											}
										],
									}
								]}
							/>
						</div>

						{!user.emailVerification &&
							<div style={{ flex: "0" }}>
								<Action
									mode={'func'}
									trigger={(click) => (<Button onClick={() => {
										POST(auth, "/api/create-email-verification", {},
											(res) => {
												click();
											}, (err) => errorCatch(err));
									}}>Подтвердить</Button>)}

									action={(values, unlock, close, { collection, setCollection }) => {
										GET(auth, '/api/email-verification-pincode?pincode=' + values.pincode,
											({ data }) => {
												if (data) {
													dispatch({ type: 'USER', payload: data })
												}
												close();
											}, (err) => errorCatch(err, unlock)
										);
									}}
									form={Model}
									meta={[
										{
											type: "func",
											render: (auth, item, value, onChange) => (<div>На указанную Вами электронную почту было отправлено письмо содержащее пинкод для подтвеждения адреса. Ввведите пинкод из электронного письма в поле ниже.</div>)
										},
										{
											label: "Пин-код",
											name: "pincode",
											type: "string",
										}
									]}
									options={{
										initialValues: {},
									}}
									title={"Подтверждение адреса электронной почты"}
									modal={{
										width: "450px",
										title: "Подтверждение адреса электронной почты",
									}}
								/>
							</div>}
					</div>
					<div style={{ paddingBottom: "20px" }}>
						<Action
							action={(values, unlock, close, { collection, setCollection }) => {
								if (!values.newPassword || values.newPassword.length < 8) {
									errorCatch("Пароль должен быть не меньше 8 символов", "error", unlock);
									return;
								}

								if (values.newPassword != values.newPasswordConfirm) {
									errorCatch("Пароли не совпадают", "error", unlock);
									return;
								}

								POST(auth, "/api/change-password", { currentPassword: values.currentPassword, newPassword: values.newPassword },
									({ data }) => {
										dispatch({ type: 'USER', payload: data })
										close();
									}, (err) => errorCatch(err, unlock)
								);
							}}
							object={{ email: user.email }}
							form={Model}
							meta={[
								{
									label: "Введите действующий пароль",
									name: "currentPassword",
									type: "password",
								},
								{
									label: "Введите новый пароль",
									name: "newPassword",
									type: "password",
								},
								{
									label: "Повторите новый пароль",
									name: "newPasswordConfirm",
									type: "password",
								}
							]}
							options={{
								initialValues: {},
							}}
							title={"Изменить пароль"}
							modal={{
								width: "450px",
								title: "Изменить пароль",
							}}
						/>
					</div>
					<div style={{ paddingBottom: "20px", display: "flex", flexDirection: "column", gap: "10px" }}>
						<div style={{ display: "flex", gap: "10px" }}>
							<a target="_blank" href={(tgbot) ? 'https://t.me/' + tgbot : "#"}>
								<div className={`bg bg-grey light-10 pointer ${(user && user.tgchatid) ? "border-green" : "border-red"}`} style={{ padding: "5px 10px", display: "flex", gap: "10px", alignItems: "center", maxWidth: "300px" }}>
									<div><i className="fa fa-telegram" style={{ fontSize: "22px" }}></i></div>
									<div style={{ fontSize: "14px", color: "rgba(0, 0, 0, 0.85)" }}>
										{(user && !user.tgchatid) && <div>Связать аккаунт c Telegram</div>}
										{(user && user.tgchatid) && <div>Ваш аккаунт связан с Telegram</div>}
									</div>
								</div>
							</a>
							{(user && user.tgchatid) && <div onClick={tgUnlink} className={`bg bg-grey light-10 pointer border-red`}><Icofont icon="close" style={{fontSize: "24px", verticalAlign: "middle"}} /></div>}
						</div>
						<div style={{ display: "flex", gap: "10px" }}>
							<a target="_blank" href={(vkbot) ? 'https://vk.com/im?sel=-' + vkbot : "#"}>
								<div className={`bg bg-grey light-10 pointer ${(user && user.vk) ? "border-green" : "border-red"}`} style={{ padding: "5px 10px", display: "flex", gap: "10px", alignItems: "center", maxWidth: "300px" }}>
									<div><i className="fa fa-vk" style={{ fontSize: "22px" }}></i></div>
									<div style={{ fontSize: "14px", color: "rgba(0, 0, 0, 0.85)" }}>
										{(user && !user.vk) && <div>Связать аккаунт c VK</div>}
										{(user && user.vk) && <div>Ваш аккаунт связан с VK!</div>}
									</div>
								</div>
							</a>
							{(user && user.vk) && <div onClick={vkUnlink} className={`bg bg-grey light-10 pointer border-red`}><Icofont icon="close" style={{fontSize: "24px", verticalAlign: "middle"}} /></div>}
						</div>
					</div>
					<Action
						mode={"inline"}
						auth={auth}
						object={user}
						okText="Сохранить"

						action={(values, unlock, close, { collection, setCollection }) => {
							let o = { ...values, ID: user.ID }//, email: values?.email?.replace(/\s/g, '') }
							POST(auth, "/api/update-user", o,
								({ data }) => {
									dispatch({ type: 'USER', payload: data })
									unlock();
								}, (err) => errorCatch(err, unlock)
							);
						}}
						form={UserUpdate}
					// form={Model}
					// meta={[
					// 	// {
					// 	// 	label: "Адрес электронной почты",
					// 	// 	name: "email",
					// 	// 	type: "string",
					// 	// },
					// 	{
					// 		label: "Фамилия",
					// 		name: "lastname",
					// 		type: "string",
					// 	},
					// 	{
					// 		label: "Имя",
					// 		name: "firstname",
					// 		type: "string",
					// 	},
					// 	{
					// 		label: "Отчество",
					// 		name: "patronymic",
					// 		type: "string",
					// 	},
					// 	{
					// 		label: "Дата рождения",
					// 		name: "birthday",
					// 		type: "date",
					// 	},
					// 	{
					// 		label: "Телефон",
					// 		name: "phone",
					// 		type: "string",
					// 	}
					// ]}
					/>

				</div>}
				{!user && <Empty
					imageStyle={{
						height: 60,
					}}
					description={
						<span>
							Нет данных
						</span>
					}
					style={{ padding: "100px 0px" }}
				>
				</Empty>}
			</div>
		</div>
	);
}
